<template>
  <div class="row" style="margin-bottom: 20px;">
    <div class="col col-12 text-center">
      <button
        class="btn btn-lg btn-primary"
        style="padding: 10px 40px !important;"
      >
        <span style="font-size: 15px !important;">
          <i v-if="icon" :class="icon" style="margin-right: 10px;"></i
          >{{ text }}
        </span>
        <img
          v-if="false"
          height="22px"
          :src="require('@/assets/img/loader.svg')"
        />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String
    }
  }
};
</script>
